import { useApi } from '@paradigm/api/src/fetch-api';
import { useDrfqService } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { Drfq } from '@paradigm/features/src/unified-rfqs/entities/drfq/domain';

import { toast } from '#/components/UnifiedRfqs/toast';
import { useUMPlatformKillDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import Button from '@paradigm/design-system/src/components/Button';
import { useTrackAction } from '@paradigm/features/src/analytics';

function CancelDrfqButton({
  rfqId,
  onCanceled,
}: {
  rfqId: Drfq['id'];
  onCanceled: () => void;
}) {
  const drfqService = useDrfqService();
  const [{ isLoading }, cancelDrfq] = useApi(drfqService.cancelDrfq);
  const isPlatformKillDisabled = useUMPlatformKillDisabled();
  const track = useTrackAction();
  const handleClick = () => {
    track('cancel rfq');
    cancelDrfq({ rfqId }, (resp) => {
      if (!resp.ok) {
        toast(resp.message);
      } else {
        onCanceled();
      }
    });
  };

  return (
    <Button
      ariaLabel="cancel rfq"
      isLoading={isLoading}
      size="large"
      disabled={isLoading || isPlatformKillDisabled}
      onClick={handleClick}
      theme="primary-red"
    >
      Cancel RFQ
    </Button>
  );
}

export default CancelDrfqButton;
